// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2FJEk","insightsList":"newBusinessInsightsMenu_insightsList__36yvj","active":"newBusinessInsightsMenu_active__i21ld"};